﻿interface ChangeEvent {
	type: ChangeEventType;
	entityId?: string;
}

enum ChangeEventType {
	Undefined,
	Holder,
	Permit,
	Reservation,
	Driver,
	Residency,
	Vehicle
}

export {ChangeEvent, ChangeEventType};
